/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {
    $Sprite,
} from '@gongxigames/framework/core/fragments/BuilderY';
import {$GameAlignContainer} from '@gongxigames/framework/slotV2/JSX/GameAlignContainer';
import {LSViewConfig} from '@gongxigames/framework/slotV2/modules/loadingScreenV2/loadingScreenViewConfig';
import {getOrientation} from '@gongxigames/framework/slotV2/modules/loadingScreenV2/utils/getOrientation';

export const renderLogo = () => (
    <$GameAlignContainer align={[0.5, 0.5]}>
        <$Sprite
            texture={LSViewConfig.logoParams.name}
            scale={getOrientation(LSViewConfig.logoParams.scale)}
            anchor={0.5}
            position={getOrientation(LSViewConfig.logoParams.position)}
        />
    </$GameAlignContainer>
);